import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/gtag";

/**
 * Tracks SPA route changes and sends pageview events to GA4.
 * Place inside <BrowserRouter>.
 */
const GARouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  return null;
};

export default GARouteTracker;
